import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiOriginalsResponse } from '@wix/da-papi-types';
import Complete from '@wix/da-ds/pkg/Icons/16x16/Complete';
import { useStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import OrdersSectionTitle from '../../OrdersSectionTitle';
import OrdersList from '../OrdersList';
import OrdersByStatusEmptyState from '../../OrdersByStatusEmptyState';
import { STUDIO_ORDERS_COMPLETED_STREAM } from '../../../../../constants';

const CompletedOrdersList: React.FC = () => {
  const { t } = useTranslation();
  const {
    items: results,
    hasMore,
    fetchNext,
  } = useStream<PapiOriginalsResponse>(
    STUDIO_ORDERS_COMPLETED_STREAM.streamId,
    STUDIO_ORDERS_COMPLETED_STREAM.streamThrottle,
    STUDIO_ORDERS_COMPLETED_STREAM.streamConfig
  );

  if (results.length < 1) {
    return (
      <OrdersByStatusEmptyState
        headerTitle={t('studio.orders.status.completed')}
        headerIcon={Complete}
        text={t('studio.orders.status.completed.emptyState')}
      />
    );
  }

  return (
    <OrdersList
      heading={
        <OrdersSectionTitle
          title={t('studio.orders.status.completed')}
          icon={Complete}
        />
      }
      results={results}
      hasMore={hasMore}
      fetchNext={fetchNext}
    />
  );
};
CompletedOrdersList.displayName = 'CompletedOrdersList';

export default CompletedOrdersList;
